module.exports = __webpack_public_path__ + "static/media/curriculum_program_combination.c2e3b8df.svg";